module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1048.f4bdc163.png";